<script setup lang="ts">
  import { reactiveOmit } from '@vueuse/core'
  import type { TabsRootProps } from 'reka-ui'
  import { TabsRoot, useForwardPropsEmits } from 'reka-ui'
  import type { HTMLAttributes } from 'vue'
  import { cn } from '../../../lib/utils'

  // Re-inline `StringOrNumber` locally to avoid the TS2883 `__VLS_base`
  // inference leak under TS 6 — reka-ui's generic defaults
  // (`TabsRootProps<T extends StringOrNumber = StringOrNumber>` and the
  // matching emits) reference the type from `dist/index3`, which isn't
  // re-exported at the top level.
  type TabValue = string | number
  type Props = Omit<TabsRootProps, 'defaultValue' | 'modelValue'> & {
    defaultValue?: TabValue
    modelValue?: TabValue
    class?: HTMLAttributes['class']
  }
  type Emits = {
    'update:modelValue': [payload: TabValue]
  }

  const props = defineProps<Props>()
  const emits = defineEmits<Emits>()

  const delegatedProps = reactiveOmit(props, 'class')
  const forwarded = useForwardPropsEmits(delegatedProps, emits)
</script>

<template>
  <TabsRoot
    data-slot="tabs"
    v-bind="forwarded"
    :class="cn('flex flex-col gap-2', props.class)"
  >
    <slot />
  </TabsRoot>
</template>
